import React from 'react';

// Extracted from StudentProfile.js (Phase 3 of the platform-health plan:
// split the file mechanically, without changing behavior).
export default function EditScheduleLessonModal({
  show,
  title,
  onTitleChange,
  date,
  onDateChange,
  allDay,
  onAllDayChange,
  from,
  onFromChange,
  to,
  onToChange,
  status,
  onStatusChange,
  editSaving,
  deleteSaving,
  onCancel,
  onDelete,
  onSave,
}) {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Edit Lesson in Schedule</h3>
        <div className="modal-row">
          <label>Title:</label>
          <input
            type="text"
            value={title}
            onChange={e => onTitleChange(e.target.value)}
            placeholder="Lesson title"
          />
        </div>
        <div className="modal-row">
          <label>Date:</label>
          <input
            type="date"
            value={date}
            onChange={e => onDateChange(e.target.value)}
          />
        </div>
        <div className="modal-row">
          <label>All Day:</label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input
              type="checkbox"
              checked={allDay}
              onChange={e => onAllDayChange(e.target.checked)}
            />
            All day event
          </label>
        </div>
        {!allDay && (
          <>
            <div className="modal-row">
              <label>From:</label>
              <input
                type="time"
                value={from}
                onChange={e => onFromChange(e.target.value)}
              />
            </div>
            <div className="modal-row">
              <label>To:</label>
              <input
                type="time"
                value={to}
                onChange={e => onToChange(e.target.value)}
              />
            </div>
          </>
        )}
        <div className="modal-row">
          <label>Status:</label>
          <select
            value={status}
            onChange={e => onStatusChange(e.target.value)}
          >
            <option value="in_progress">In Progress</option>
            <option value="done">Done</option>
            <option value="cancelled">Cancelled</option>
            <option value="scheduled">Scheduled</option>
          </select>
        </div>
        <div className="modal-actions">
          <button
            type="button"
            onClick={onCancel}
            disabled={editSaving || deleteSaving}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`schedule-modal-delete-btn${deleteSaving ? ' schedule-add-btn-loading' : ''}`}
            onClick={onDelete}
            disabled={editSaving || deleteSaving}
          >
            {deleteSaving ? (
              <span className="schedule-add-btn-spinner" aria-hidden />
            ) : (
              'Delete'
            )}
          </button>
          <button
            type="button"
            onClick={onSave}
            disabled={editSaving || deleteSaving}
            className={editSaving ? ' schedule-add-btn-loading' : ''}
          >
            {editSaving ? (
              <span className="schedule-add-btn-spinner" aria-hidden />
            ) : (
              'Save'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
